import { Privilege } from "./index";

export class Role {
    ID: string;
    NAME: string;
    CODE: string;
    DESC: string;
    AVAILABLE_FOR_ORG: boolean;
    PRIVILEGES: Array<Privilege>;

    static parse(json: any): Role {
        if (json) {
            const r = new Role();

            r.ID = json.ID;
            r.NAME = json.NAME;
            r.CODE = json.CODE;
            r.DESC = json.DESC;
            r.AVAILABLE_FOR_ORG = json.AVAILABLE_FOR_ORG;

            if (json.PRIVILEGES)
                r.PRIVILEGES = Role.parseArray(json.PRIVILEGES);

            return r;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Role> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Role.parse(j));

        return arr;
    }
}
